/* Http Client */
import request from '@/utils/http/request'



export const _TRANSACTION_TYPE = {
    1: "儲值獲得",
    2: "活動消費",
    3: "場地消費",
    4: "轉讓",
    5: "退款返還",
    6: "儲值退款",
    7: "註冊獲得",
    8: "人工調整",
    9: "接收轉讓",
    10: "轉讓過期退還",
    11: "過期扣款"
}
export const _TYPE = {
    1: "付費點數",
    2: "免費點數"
}
export const _WAYTYPE = { 1: "加金", 2: "減金" }

//List
export async function fetchAll({ name, orderId, phone, sDate, eDate, transactionType, pageSize, pageNumber }) {
    return await request.get('/members/points', {
        params: {
            name, orderId, phone, sDate, eDate, transactionType, pageSize, pageNumber
        }

    });
}

export async function update({ id, transactionType, pointsAmount, transactionDesc }) {
    return await request.put(`/members/points/${id}`, {
        transactionType, pointsAmount, transactionDesc
    });
}

